module.exports = __webpack_public_path__ + "img/404_desktop_portrait.63798828.png";